import api from '@api/endpoints';
import { ALERT_STATUS_TYPE } from '@constants';
import { setAlert } from '@store/actions/alertActions';


export const updateUserDetails =
  ({ userId, fieldName, fieldValue, onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const requestBody = {
        [fieldName]: fieldValue
      };
      const { data } = await api.cxTechOperations.updateUserDetails({
        userId,
        requestBody
      });
      dispatch(
        setAlert({
          title: data?.status || 'Successfully updated',
          status: ALERT_STATUS_TYPE.SUCCESS
        })
      );
      onSuccess && onSuccess();
    } catch (error) {
      dispatch(
        setAlert({
          title: `${error?.message}`,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };
